import { render, staticRenderFns } from "./EffectFreeNotice.vue?vue&type=template&id=a6ace684&"
import script from "./EffectFreeNotice.vue?vue&type=script&lang=js&"
export * from "./EffectFreeNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports